import AsyncCallHandler from "../common/AsyncCallHandler";
import ACTION_TYPES from "./actionTypes";
import NEXUS_CONST from "../common/constants";
import { set, get } from "../common/utils";
import { jsonParse } from "../oidcauthentication/utils";

export const fetchSiteLocations = (dispatch, sbg) => {

    AsyncCallHandler(NEXUS_CONST.SITE_LOCATION_URL + sbg, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.FETCH_SBG_LOCATIONS, payload: res.data });
        });
};

export const fetchPinnedSites = (dispatch, sbg) => {

    AsyncCallHandler(NEXUS_CONST.FETCH_PINNED_SITES + sbg, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.FETCH_PINNED_SITES, payload: res.data });
        });
};



export const getUserData = (dispatch, site) => {

    AsyncCallHandler(NEXUS_CONST.GET_USER_DATA + site, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.GET_USER_DATA, payload: res.data });
        });
};

export const updatePinSite = (dispatch, urlProps, sbg) => {

    AsyncCallHandler(NEXUS_CONST.UPDATE_PIN_SITE + urlProps, NEXUS_CONST.GET)
        .then((res) => {
            fetchSiteLocations(dispatch, sbg);
            fetchPinnedSites(dispatch, sbg);
            //dispatch({ type: ACTION_TYPES.UPDATE_PIN_SITE, payload: res.data });
        });
}

// export const fetchWeatherData = (dispatch, site) => {
//     const { siteId } = site;
//     let weatherInfo = get('weatherInfo');
//     let siteKey = 'id_' + siteId;

//     if (weatherInfo && weatherInfo[siteKey]) {
//         if (weatherInfo[siteKey].units === site.tempUnit)
//             dispatch({ type: ACTION_TYPES.RECEIVE_WEATHER_FORECASTS, forecasts: weatherInfo[siteKey] });
//     }

//     let weatherData = weatherInfo
//     if (!weatherData) {
//         weatherData = {};
//     }
//     AsyncCallHandler(NEXUS_CONST.OPEN_WEATHER_URL + `lat=${site.siteLatitude}&lon=${site.siteLongitude}&units=${site.tempUnit}`, NEXUS_CONST.GET)
//         .then(res => {
//             weatherData[siteKey] = res.data
//             set('weatherInfo', weatherData)
//             dispatch({ type: ACTION_TYPES.RECEIVE_WEATHER_FORECASTS, forecasts: res.data });
//         });
// }

export const fetchTiers = (dispatch, site) => {

    AsyncCallHandler(NEXUS_CONST.FETCH_TIERS + site, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.FETCH_TIERS, payload: res.data });
        });
};

export const getKRecognitions = (dispatch, site) => {
    AsyncCallHandler(
        "Kaizen/getRecognitionDetails?siteId=" + site,
        NEXUS_CONST.GET
      ).then((res) => {
        dispatch({ type: ACTION_TYPES.FETCH_KRECOG, payload: res.data });
      });
};

export const getKCategory = (dispatch, site) => {
    AsyncCallHandler(
        "KaizenAdmin/getCategoryList?siteId=" + site,
        NEXUS_CONST.GET
      ).then((res) => {
        dispatch({ type: ACTION_TYPES.FETCH_KCATEGORY, payload: res.data });
      });
};

export const updateKCate = (dispatch, data, site) => {
    AsyncCallHandler("KaizenAdmin/ManageCategory", NEXUS_CONST.POST, data).then(
        (res) => {
          dispatch({ type: ACTION_TYPES.FETCH_CATEGORY_SAVE, payload: res.data });
          getKCategory(dispatch, site);
        }
      );
};

export const delKCate = (dispatch, id, site) => {
    AsyncCallHandler(
        "KaizenAdmin/deleteCategory?id=" + id,
        NEXUS_CONST.POST
      ).then((res) => {
        getKCategory(dispatch, site);
      });
};

export const fetchTemplate = (dispatch, prop) => {

    AsyncCallHandler(NEXUS_CONST.FETCH_TPL + prop, NEXUS_CONST.GET).then(
        (res) => {
          dispatch({ type: ACTION_TYPES.FETCH_TEMPLATE, payload: jsonParse(res.data) });
        }
      );
};

export const fetchActiveTemplate = (dispatch, prop) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_TPL + prop, NEXUS_CONST.GET).then(
      (res) => {
        const parsedData = jsonParse(res.data);
        if(Array.isArray(parsedData)){
        let tpl = parsedData.filter((d) => {
          if (d.isActive) return d;
        });
        dispatch({ type: ACTION_TYPES.FETCH_TEMPLATE, payload: tpl });
      }
    }
    );
  };


export const updateTemplate = (dispatch, data, isPreview) => {

    AsyncCallHandler(NEXUS_CONST.UPDATE_TEMPLATE, NEXUS_CONST.POST, data).then(
        (res) => {
          fetchPublishedTpl(
            dispatch,
            `siteid=${data.siteId}&tierid=${data.tierId}`
          );
          dispatch({
            type: isPreview ? ACTION_TYPES.PREVIEW : ACTION_TYPES.UPDATE_TEMPLATE,
            payload: res.data,
          });
        }
      );
};



export const getTableuaData = (dispatch, tier) => {

    AsyncCallHandler(NEXUS_CONST.FETCH_TABLEUA_DATA + tier, NEXUS_CONST.GET)
        .then((res) => {

            dispatch({ type: ACTION_TYPES.FETCH_TABLEUA_DATA, payload: res.data });
        });
};

export const getQuickLinkInfo = (dispatch, site) => {

    AsyncCallHandler(NEXUS_CONST.QUICK_LINK_INFO + site, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.QUICK_LINK_INFO, payload: res.data });
        });
};

export const getTierInfo = (dispatch, prop) => {

    AsyncCallHandler(NEXUS_CONST.GET_TIER_INFO + prop, NEXUS_CONST.GET)
        .then((res) => {

            dispatch({ type: ACTION_TYPES.GET_TIER_INFO, payload: res.data });
        });
};

export const saveMeetingDuration = (dispatch, prop) => {
    AsyncCallHandler(NEXUS_CONST.UPDATE_MEET_TIME, NEXUS_CONST.POST, prop)
        .then((res) => {
        });
};

export const getSessionInfo = (dispatch) => {
    AsyncCallHandler(NEXUS_CONST.GET_SESSION_INFO, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.GET_SESSION_INFO, payload: res.data });
        });
};

export const getUserInfoByCode = (dispatch, code) => {
    AsyncCallHandler(NEXUS_CONST.GET_USER_BY_CODE + code, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.GET_USER_BY_CODE, payload: res.data });
        });
};

export const validateSession = (dispatch, data,) => {
    AsyncCallHandler(NEXUS_CONST.VALIDATE_SESSION, NEXUS_CONST.POST, data)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.VALIDATE_SESSION, payload: res.data });
        });
};

export const getSiteInfo = (dispatch, code) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_SITE_INFO + code, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.FETCH_SITE_INFO, payload: res.data });
        });
};

export const fetchCalendarUpcomingEvent = (dispatch, site) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_CALENDAR_UPCOMING_EVENT + `siteId=${site.siteId}&upcomingEvent=${site.upcomingEvent}`, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.FETCH_CALENDAR_UPCOMING_EVENT, payload: res.data });
        });
};

export const saveLayoutFile = (dispatch, data, props) => {
    AsyncCallHandler(NEXUS_CONST.SAVE_LAYOUT_FILE + props, NEXUS_CONST.PUT, data)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.SAVE_LAYOUT_FILE, payload: res.data });
        });
};

export const fetchPublishedTpl = (dispatch, prop) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_TPL + prop, NEXUS_CONST.GET)
        .then((res) => {
            
            dispatch({ type: ACTION_TYPES.FETCH_PUBLISHED_TPL, payload: jsonParse(res.data) });
        });
};

export const getTableuaAccess = (dispatch) => {

    AsyncCallHandler(NEXUS_CONST.FETCH_TABLEAU_ACCESS, NEXUS_CONST.GET)
        .then((res) => {

            dispatch({ type: ACTION_TYPES.FETCH_TABLEAU_ACCESS, payload: res.data });
        });
};

export const getWBData = (dispatch, code) => {
    AsyncCallHandler("home/getWhiteboardData?siteId=" + code, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.FETCH_WB_INFO, payload: res.data });
        });
};

export const updateWBData = (dispatch, data) => {
    AsyncCallHandler("home/manageWhiteboardData", NEXUS_CONST.POST, data).then(
        (res) => {}
      );
};

export const getTableuaInfo = (dispatch, prop) => {
    AsyncCallHandler("digitaltier/getTablueaLayout?" + prop, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.GET_TABLEUA_INFO, payload: res.data });
        });
};

export const fetchUserHighestTier = (dispatch) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_USER_HIGHEST_TIER, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.GET_USER_HIGHEST_TIER, payload: res.data.toString() });
        });
};

export const fetchSiteHighestTier = (dispatch, site) => {
    AsyncCallHandler(NEXUS_CONST.FETCH_SITE_HIGHEST_TIER + site, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.GET_SITE_HIGHEST_TIER, payload: res.data });
        });
};

export const fetchImage = (dispatch, data) => {
    AsyncCallHandler(NEXUS_CONST.GET_IMAGE, NEXUS_CONST.POST, data)
        .then((res) => {
            const parsedData = jsonParse(res.data);
            dispatch({ type: ACTION_TYPES.GET_IMAGE, payload: parsedData });
        });
};

export const getUserDataAppAccess = (dispatch, site) => {

    AsyncCallHandler(NEXUS_CONST.GET_USER_DATA_ACCESS + site, NEXUS_CONST.GET)
        .then((res) => {
            dispatch({ type: ACTION_TYPES.GET_USER_DATA_ACCESS, payload: res.data });
        });
};

export const getSubTiers = (dispatch, prop) => {
    AsyncCallHandler("Settings/getSubTierListData?TierID=" + prop, NEXUS_CONST.GET)
        .then(res => {
            dispatch({ type: "FETCH_SUB_TIERS", payload: res.data });
        });
};